module.exports = __webpack_public_path__ + "static/media/TDOGE-BNB.193ffbf7.svg";